import React, { Component } from "react";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import jwtDecoder from "jwt-decode";
import AuthRoute from "./util/AuthRoute";
import ProtectedRoute from "./util/ProtectedRoute";

//pages
import parkingStatus from "./pages/parkingStatus";
import signup from "./pages/signup";
import login from "./pages/login";
import userInfo from "./pages/userInfo";
import homepage from "./pages/homepage";
import index from "./pages/index";
import editParkingInfo from "./pages/editParkingInfo";

//style
import "./styles/App.scss";

// redux
import { Provider } from "react-redux";
import store from "./redux/store";
import { SET_AUTHENTICATED } from "./redux/types";
import { logoutUser } from "./redux/actions/userActions";
import axios from "axios";
import parkingUserData from "./pages/parkingUserData";

// axios.defaults.baseURL =
//   "http://localhost:5000/ipark-app-3143c/us-central1/api";
axios.defaults.baseURL =
  "https://us-central1-ipark-app-3143c.cloudfunctions.net/api";

const token = localStorage.firebaseIdToken;

if (token) {
  const decodedToken = jwtDecoder(token);
  if (decodedToken.exp * 1000 < Date.now()) {
    store.dispatch(logoutUser());
    window.location.href = "/about";
  } else {
    store.dispatch({ type: SET_AUTHENTICATED });
    axios.defaults.headers.common["Authorization"] = token;
  }
}

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <div className="App">
          <Router>
            <Switch>
              <ProtectedRoute exact path="/" component={index} />
              <AuthRoute exact path="/about" component={homepage} />
              <ProtectedRoute
                exact
                path="/parking-logs"
                component={parkingUserData}
              />
              <ProtectedRoute
                exact
                path="/editParkingInfo"
                component={editParkingInfo}
              />
              <ProtectedRoute exact path="/parking" component={parkingStatus} />
              <AuthRoute exact path="/signup" component={signup} />
              <AuthRoute exact path="/login" component={login} />
              <ProtectedRoute exact path="/user" component={userInfo} />
            </Switch>
          </Router>
        </div>
      </Provider>
    );
  }
}

export default App;
